import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'

import userInfoReducer from './userInfo'
import globalErrorReducer from './globalError'
import themeModeReducer from './themeMode'
import gnbToggleReducer from './gnbToggle'
import cmmnCodeReducer from './cmmnCodeFactory'
import gridColumnReducer from './gridColumn'
import pagePosReducer from './pagePos'
import deviceInfoReducer from './deviceInfo'

const reducers = combineReducers({
	cmmnCodeFactory: cmmnCodeReducer,
	userInfo: userInfoReducer,
	displayMode: themeModeReducer,
	gnbToggle: gnbToggleReducer,
	gridColumnOrderInfo: gridColumnReducer,
	pagePos: pagePosReducer,
	globalError: globalErrorReducer,
	deviceInfo: deviceInfoReducer,
})

const persistConfig = {
	key: 'root',
	storage,
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = configureStore({
	reducer: persistedReducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware: [thunk],
})

export default store
